<template>
  <div class="empty">
    <SvgIcon icon-class="coc-empty" class-name="empty-icon" />
  </div>
</template>

<script>
import SvgIcon from '@/components/behavior/svg-icon/index.vue'
export default {
  name: 'InactiveEmpty',
  components: {
    SvgIcon,
  },
}
</script>

<style scoped>
.empty {
  width: 100%;
  height: 100%;
  background-color: #f7f8fa;
  box-shadow: 5px 0px 10px 0px rgba(151, 171, 199, 0.06);
  display: flex;
}
.empty-icon {
  width: 412px;
  height: 102px;
  margin: auto;
}
</style>
